import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UniversitySquaresHorizontalLineComponent} from './components/squares-horizontal/university-squares-horizontal-line.component';
import {UniversitySquaresVerticalLineComponent} from './components/squares-vertical/university-squares-vertical-line.component';
import {FilterSearchHipPipe} from './pipes/filterSearch/filter-search-hip.pipe';
import {CutTitlePipe} from './pipes/titlePipe/cut-title.pipe';
import {FilterSearchVtcPipe} from './pipes/filterSearch/filter-search-vtc.pipe';
import {FilterStudyProgrammeSearchPipe} from './pipes/filterSearch/filter-search-sp.pipe';
import {TitlePipe} from './pipes/titlePipe/title.pipe';
import {VtcTitlePipe} from './pipes/titlePipe/vtc-title.pipe';
import {FilterSearchSpMeetingPipe} from './pipes/filterSearch/filter-search-sp-meeting.pipe';
import {FilterSearchSpEvaluationPipe} from './pipes/filterSearch/filter-search-sp-evaluation.pipe';


@NgModule({
  declarations: [
    UniversitySquaresHorizontalLineComponent,
    UniversitySquaresVerticalLineComponent,
    TitlePipe,
    FilterStudyProgrammeSearchPipe,
    FilterSearchHipPipe,
    FilterSearchVtcPipe,
    CutTitlePipe,
    VtcTitlePipe,
    FilterSearchSpMeetingPipe,
    FilterSearchSpEvaluationPipe,
  ],
    exports: [
        UniversitySquaresHorizontalLineComponent,
        UniversitySquaresVerticalLineComponent,
        TitlePipe,
        FilterStudyProgrammeSearchPipe,
        FilterSearchHipPipe,
        FilterSearchVtcPipe,
        CutTitlePipe,
        VtcTitlePipe,
        FilterSearchSpMeetingPipe,
        FilterSearchSpEvaluationPipe,
    ],
  imports: [
    CommonModule,
  ]
})
export class SharedModule {
}
